module.exports = "<div class=\"overlay-screen-wrapper\" *ngIf=\"visible == true\">\r\n    <div class=\"overlay-screen\">\r\n        <h2 class=\"text-center\" [innerHTML]=\"title\"></h2>\r\n        <br />\r\n        <div [innerHTML]=\"content\"></div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/generic-page/generic-page.component.html
// module id = m/j0
// module chunks = 1